var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrDisplay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 6C1.3335 4.11467 1.3335 3.17133 1.9195 2.586C2.50483 2 3.44816 2 5.3335 2H10.6668C12.5522 2 13.4955 2 14.0808 2.586C14.6668 3.17133 14.6668 4.11467 14.6668 6V6.66667C14.6668 8.552 14.6668 9.49533 14.0808 10.0807C13.4955 10.6667 12.5522 10.6667 10.6668 10.6667H5.3335C3.44816 10.6667 2.50483 10.6667 1.9195 10.0807C1.3335 9.49533 1.3335 8.552 1.3335 6.66667V6Z",
    stroke: "#EE2B2A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.6667V11M8 12.6667L12 14M8 12.6667L4 14",
    stroke: "#EE2B2A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrDisplay);
export default __webpack_public_path__ + "static/media/xr-display.ada900c9b5d413028ec37d48e1799448.svg";
export { ForwardRef as ReactComponent };